/* =========================================================
   NC MINI CART — SUPLEMENTOS VIKINGO ESPAÑA
   Mejora ligera del drawer premium
   ========================================================= */

(function () {
  if (window.__ncMiniCartPremiumLoaded) return;
  window.__ncMiniCartPremiumLoaded = true;

  function getDrawer() {
    return document.querySelector('[data-nc-mini-cart]');
  }

  function focusCloseButton(drawer) {
    if (!drawer) return;

    var closeButton = drawer.querySelector('.nc-mini-cart__close');

    if (closeButton && typeof closeButton.focus === 'function') {
      window.setTimeout(function () {
        closeButton.focus({ preventScroll: true });
      }, 80);
    }
  }

  function observeDrawer() {
    var drawer = getDrawer();

    if (!drawer || drawer.dataset.ncMiniObserved === 'true') return;

    drawer.dataset.ncMiniObserved = 'true';

    var observer = new MutationObserver(function () {
      var isOpen =
        drawer.hasAttribute('open') ||
        drawer.classList.contains('active') ||
        drawer.classList.contains('is-open');

      if (isOpen) {
        focusCloseButton(drawer);
      }
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['open', 'class']
    });
  }

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest('[data-nc-checkout-button]');

    if (!checkoutButton) return;

    checkoutButton.classList.add('is-loading');
  });

  document.addEventListener('shopify:section:load', function () {
    observeDrawer();
  });

  document.addEventListener('DOMContentLoaded', function () {
    observeDrawer();
  });

  observeDrawer();
})();